






























































import Vue from 'vue';
import { mapGetters, mapState, mapMutations, mapActions } from 'vuex';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';
import {IStatisticsSummary, IStatisticsSummaryDetail} from '../shared/services/models/StatisticsSummaries';
import {IInterface, IMultipleOutputs, ITag} from '../shared/services/models/Interface';
import { ISetting } from '../shared/services/models/Setting';

interface IInterfaceStatistics {
    ActiveCount: number;
    TotalCount: number;
    TxCount: number;
    RxCount: number;
    BitrateIn: number;
    BitrateOut: number;
}

@Component({
    components: {
        // @ts-ignore
        CopyrightComponent : require('@/components/Copyright').default,
        // @ts-ignore
        ConnectionComponent : require('@/components/Connection').default,
    },
    computed: {
        ...mapState(['interfaces', 'statisticsSummary', 'tags', 'settings', 'updating']),
    },
    methods: {
        ...mapActions(['updateInterfaces', 'updateStatisticsSummary', 'updateStatus', 'updateTags', 'startInterface', 'stopInterface', 'restartInterface']),
    },
})
export default class DashboardComponent extends Vue {
    private statisticsSummary!: IStatisticsSummary;
    private interfaces!: IInterface[];
    private tags!: ITag[];
    private settings!: ISetting[];
    private updating!: boolean;

    private statisticsSummaryUpdateHanbdle: number = 0;
    private shiftDown: boolean = false;
    private tagFilter: string | undefined = 'all';

    @Watch('tagFilter')
    private tagFilterChange(newValue: string) {
        localStorage.setItem('tag-filter-value', newValue);
    }

    private mounted() {
        const tagfilter = localStorage.getItem('tag-filter-value');
        if (tagfilter) {
            this.tagFilter = tagfilter;
        }
        // @ts-ignore
        this.updateTags();
        // @ts-ignore
        this.updateInterfaces();
        // @ts-ignore
        this.updateStatisticsSummary();
        // @ts-ignore
        this.updateStatus();
        // @ts-ignore
        this.statisticsSummaryUpdateHanbdle = setInterval(() => {
            // @ts-ignore
            this.updateStatisticsSummary();
            // @ts-ignore
            this.updateInterfaces();
            // @ts-ignore
            this.updateStatus();
        }, 10000);

        window.addEventListener('keyup', (e: KeyboardEvent) => {
            this.shiftDown = e.shiftKey;
        });
        window.addEventListener('keydown', (e: KeyboardEvent) => {
            this.shiftDown = e.shiftKey;
        });
    }

    private get Interfaces(): IInterface[] {
        const ret: IInterface[] = [];
        const updated: boolean = this.updating;

        if (this.interfaces) {
            this.interfaces.sort((l: IInterface, r: IInterface) => {
                if (l.nr < r.nr) {
                    return -1;
                } else if (l.nr > r.nr) {
                    return 1;
                }

                return 0;
            }).forEach((i) => {
                if (i.live || ((Array.isArray(i.input) && i.input.length > 0) && (Array.isArray(i.output) && i.output.length > 0) || (i.output as IMultipleOutputs).multi)) {
                    if (this.isInterfaceVisible(i)) {
                        ret.push(i);
                    }
                }
            });
        }

        return ret;
    }

    private get TagFilters(): any[] {
        const ret: any[] = [];

        ret.push({ value: 'all', text: 'All'});
        ret.push({
            label: 'Filters',
            options: [
                { value: 'filter:active', text: 'Active' },
                { value: 'filter:idle', text: 'Idle' },
               /* { value: 'filter:configured', text: 'Configured' },
                { value: 'filter:free', text: 'Free' }, */
            ],
        });
        const ltags = {
            label: 'Tags',
            options: [] as any[],
        };

        this.tags.forEach((t) => {
            const value: string = t.id;
            const text: string = t.name;
            ltags.options.push(
                {
                    value,
                    text,
                });
        });

        ret.push(ltags);

        return ret;
    }

    private get IsFilterIsTag(): boolean {
        if (!this.tagFilter || this.tagFilter === 'all' || this.tagFilter.indexOf('filter:') !== -1) {
            return false;
        }

        return true;
    }

    private get Tags(): ITag[] {
        if (this.tags) {
            return this.tags;
        }

        return [];
    }

    private getStatisticsFor(id: string): IStatisticsSummaryDetail {
        for (const iterator of this.statisticsSummary.short_interval) {
            if (iterator.interface_id === id) {
                return iterator;
            }
        }

        return {
            interface_id: '',
            in_retransmitted: -1,
            out_retransmitted: -1,
            in_dropped: -1,
            out_dropped: -1,
            in_bitrate: -1,
            out_bitrate: -1,
            connected_input_clients: [],
            connected_output_clients: [],
        };
    }

    private destroyed() {
        clearInterval(this.statisticsSummaryUpdateHanbdle);
    }

    private isInterfaceVisible(inter: IInterface) {
        if (!this.tagFilter || this.tagFilter === 'all') {
            return true;
        }

        if (this.tagFilter.indexOf('filter:') !== -1) {
            switch (this.tagFilter.toLowerCase()) {
                case 'filter:active': return inter.live && inter.live.state === 1;
                case 'filter:idle': return (inter.live && inter.live.state === 0) || inter.live === undefined;
                case 'filter:configured': return (Array.isArray(inter.input) && inter.input.length !== 0 || ( Array.isArray(inter.output) && inter.output.length > 0) || !Array.isArray(inter.output) && inter.output.multi || !Array.isArray(inter.input) && inter.input.multi);
                case 'filter:free': return (Array.isArray(inter.input) && inter.input.length === 0 && ( Array.isArray(inter.output) && inter.output.length === 0));
            }
        } else {
            if (inter && inter.tags && inter.tags.length > 0) {
                // tslint:disable-next-line
                for (let i: number = 0; i < inter.tags.length; i++) {
                    const tag: ITag = inter.tags[i];

                    if (tag.id === this.tagFilter) {
                        return true;
                    }
                }
            }
        }

        return false;
    }

     private startAllInterfacesVisible(): void {
        let iNames: string = '';
        this.interfaces.forEach((i) => {
            if (this.isInterfaceVisible(i)) {
                if (iNames.length > 0) {
                    iNames += ', ';
                }
                iNames += i.name;
            }
        });
        this.$bvModal.msgBoxConfirm(`Start ${iNames}`, {
            title: 'Start all visible Interfaces',
            size: 'sm',
            buttonSize: 'sm',
            okVariant: 'danger',
            okTitle: 'YES',
            cancelTitle: 'NO',
            footerClass: 'p-2',
            hideHeaderClose: false,
            centered: true,
        })
        .then((value) => {
            if (value) {
                this.interfaces.forEach((i) => {
                    if (this.isInterfaceVisible(i)) {
                        this.Start(i);
                    }
                });
            }
        })
        .catch((err) => {
            // An error occurred
        });
    }

    private stopAllInterfacesVisible(): void {
        let iNames: string = '';
        this.interfaces.forEach((i) => {
            if (this.isInterfaceVisible(i)) {
                if (iNames.length > 0) {
                    iNames += ', ';
                }
                iNames += i.name;
            }
        });
        this.$bvModal.msgBoxConfirm(`Stop ${iNames}`, {
            title: 'Stop all visible Interfaces',
            size: 'sm',
            buttonSize: 'sm',
            okVariant: 'danger',
            okTitle: 'YES',
            cancelTitle: 'NO',
            footerClass: 'p-2',
            hideHeaderClose: false,
            centered: true,
        })
        .then((value) => {
            if (value) {
                this.interfaces.forEach((i) => {
                    if (this.isInterfaceVisible(i)) {
                        this.Stop(i);
                    }
                });
            }
        })
        .catch((err) => {
            // An error occurred
        });
    }

    private restartAllInterfacesVisible(): void {
        let iNames: string = '';
        this.interfaces.forEach((i) => {
            if (this.isInterfaceVisible(i)) {
                if (iNames.length > 0) {
                    iNames += ', ';
                }
                iNames += i.name;
            }
        });
        this.$bvModal.msgBoxConfirm(`Restart ${iNames}`, {
            title: 'Restart all visible Interfaces',
            size: 'sm',
            buttonSize: 'sm',
            okVariant: 'danger',
            okTitle: 'YES',
            cancelTitle: 'NO',
            footerClass: 'p-2',
            hideHeaderClose: false,
            centered: true,
        })
        .then((value) => {
            if (value) {
                this.interfaces.forEach((i) => {
                    if (this.isInterfaceVisible(i)) {
                        this.Restart(i);
                    }
                });
            }
        })
        .catch((err) => {
            // An error occurred
        });
    }

    private Start(i: IInterface) {
        const id: string = i.id;
        const nr: number = i.nr;
        // @ts-ignore
        this.startInterface({id, nr});
    }

    private Stop(i: IInterface) {
        const id: string = i.id;
        const nr: number = i.nr;
        // @ts-ignore
        this.stopInterface({id, nr});
    }

    private Restart(i: IInterface) {
        const id: string = i.id;
        const nr: number = i.nr;
        // @ts-ignore
        this.restartInterface({id, nr});
    }
}
